import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";
import { PageSkeleton } from "@/components/PageSkeleton";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) return <PageSkeleton />;
  if (!user) return <Navigate to="/auth" replace />;

  return <>{children}</>;
}
